import { cn } from '@repo/lib/cn';

import { Markdown } from '@/components/ui/markdown';
import { RadioGroupItem } from '@/components/ui/radio-group';
import { questionCorrect } from '@/lib/quiz';

import type { QuestionSingleAnswerProps } from '.';

export function QuestionSingleAnswer(questionSingleProps: QuestionSingleAnswerProps) {
  const { answer, showMarked, correct, disabled, ...props } = questionSingleProps;

  const { getStateClassNames, getIcon } = questionCorrect(correct);

  return (
    <div
      data-correct={correct}
      className={cn('relative flex w-full cursor-pointer items-start gap-2 rounded-md border p-3 shadow-xs transition-colors duration-100 outline-none md:p-4', getStateClassNames())}
    >
      <RadioGroupItem
        id={answer.id}
        value={answer.id}
        aria-describedby={`${answer.id}-description`}
        data-correct={correct}
        className="static mt-1 shrink-0 after:absolute after:inset-0 after:z-20"
        disabled={showMarked || disabled}
        {...props}
      />
      <div className="min-w-0 grow space-y-2">
        <Markdown content={answer.content} imageClassName={'max-h-68 rounded-sm'} videoClassName={'max-h-68 rounded-sm'} />
      </div>
      {getIcon()}
    </div>
  );
}
